module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/jkcyc.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fjkcyc.png
// module id = L6qQ
// module chunks = 93